require('./brokerRequestFinancialOperationChangeStep2.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKTooltip = require('commonsComponents/OKTooltip');

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
    BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_SIGNATURE_PATTERN_OPERATION_TYPE,
    BROKER_CORPORATE_OPERATIONS_URL,
    SECOND_STEP,
    BROKER_PRODUCT_TYPE_EXCHANGE
} = require('constants/index');

class BrokerRequestFinancialOperationChangeStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.handleBack = this.handleBack.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleBack() {
        this.props.history.goBack();
    }

    handleCancel() {
        this.props.history.push(BROKER_CORPORATE_OPERATIONS_URL);
    }

    render() {
        const {
            immBrokerRequestFinancialOperationChange,
            onConfirmOperationCheckbox,
            setDocumentsRead
        } = this.props;

        const product = immBrokerRequestFinancialOperationChange.get('contrato').get('product');
        const contractNumber = immBrokerRequestFinancialOperationChange.get('contrato').get('number');

        const signaturePatternParams = {
            chargeAccount: `00730100${product}${contractNumber}`
        };
        const secondStep = immBrokerRequestFinancialOperationChange.getIn(['steps', SECOND_STEP]);
        const manifestNotChecked = secondStep.get('manifestNotChecked');
        const isin = immBrokerRequestFinancialOperationChange.getIn(['valor', 'isin'])
        const iso = immBrokerRequestFinancialOperationChange.getIn(['valor', 'iso'])
        const showWarning = secondStep.get('showWarning')
        const productDefinition = immBrokerRequestFinancialOperationChange.getIn(['valor', 'descriptionValue'])

        const showSignaturePattern = () => {
            setDocumentsRead()
        }

        let documentsNotRead = null;
        if (showWarning) {
            documentsNotRead = (
                <div className="broker-request-financial-operation-change-step2__warning-message">
                    <OKMessage type="warning">
                        <FormattedText value="brokerLegalDocumentation-documentsRead" />
                    </OKMessage>
                </div>
            )
        }

        let signaturePattern = null;
        if (secondStep.get('acceptedManifest')) {
            signaturePattern = (
                <div className="broker-request-financial-operation-change-step2__signature-pattern">
                    <SignaturePattern
                        operationType={BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_SIGNATURE_PATTERN_OPERATION_TYPE}
                        operationParams={signaturePatternParams}
                    />
                </div>
            )
        }

        return (
            <OKSectionBox>
                <h3 className="broker-request-financial-operation-change-step2__title">
                    <FormattedText value="requestFinancialOperationChange-subscriptionConfirmation"/>
                </h3>
                <div className="broker-request-financial-operation-change-step2__field">
                    <h4><FormattedText value="requestFinancialOperationChange-verifyInformation"/></h4>
                </div>
                <div className="broker-request-financial-operation-change-step2__manifest">
                    <BrokerLegalDocumentation
                        isin={isin}
                        iso={iso}
                        productDefinition={productDefinition}
                        productType={BROKER_PRODUCT_TYPE_EXCHANGE}
                        reportCompleted={() => showSignaturePattern()}
                    />
                    {documentsNotRead}
                    <OKTooltip
                        content={<FormattedText value={'planLegalDocumentDisclaimer-warningTooltip'}/>}
                        offset={[-50, -5]}
                        placement={'topLeft'}
                        target={
                            <div className="broker-request-financial-operation-change-step2__disclaimer">
                                <OKCheckbox
                                    idName="operationCheckbox"
                                    onChange={onConfirmOperationCheckbox}
                                    value={secondStep.get('acceptedManifest')}
                                    errorState={manifestNotChecked}
                                    errorMessage={formatText('requestFinancialOperationChange-checkError')}
                                    label={formatText('requestFinancialOperationChange-manifest')}
                                />
                            </div>
                        } />

                </div>
                {signaturePattern}
            </OKSectionBox>
        );
    }
}

BrokerRequestFinancialOperationChangeStep2.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerRequestFinancialOperationChange: PropTypes.object.isRequired,
    onConfirmOperationCheckbox: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired
};

module.exports = withRouter(BrokerRequestFinancialOperationChangeStep2);
